export const TELLER_TESTS_HEADER =[
    { property: 'project', label: 'Project'},
    { property: 'description', label: 'Description' },
    { property: 'business', label: 'Business' },
    { property: 'subBusiness', label: 'Sub Business' },
    { property: 'country', label: 'Country'},
    { property: 'paymentMethod', label: 'Payment Method'},
    { property: 'currency', label: 'Currency'},
    { property: 'supplierSite', label: 'Supplier Site'},
    { property: 'expectedResult', label: 'Expected Outcome'}
];

export const OFA_TESTS_HEADER =[
    { property: 'project', label: 'Project'},
    { property: 'description', label: 'Description' },
    { property: 'invoice', label: 'Invoice Number' },
    { property: 'paymentTemplate', label: 'payment Template'},
    { property: 'expectedResult', label: 'Expected Outcome'}
];

export const serviceDropdownOptions = [
    {
        name: 'Teller',
        value: 'Teller'
    },
    {
        name: 'OFA',
        value: 'OFA'
    }
]

export const TESTS_EXECUTION_HEADER =[
    { property: 'description', label: 'Description' },
    { property: 'business', label: 'Business' },
    { property: 'subBusiness', label: 'Sub Business' },
    { property: 'supplierSite', label: 'Supplier Site' },
    { property: 'country', label: 'Country'},
    { property: 'paymentMethod', label: 'Payment Method'},
    { property: 'currency', label: 'Currency'},
    { property: 'amount', label: 'Amount'},
    { property: 'expectedResult', label: 'Expected Outcome'}
];

export const OFA_EXECUTION_HEADER =[
    { property: 'description', label: 'Description' },
    { property: 'invoice', label: 'Invoice Number' },
    { property: 'paymentTemplate', label: 'Payment Template Name' },
    { property: 'expectedResult', label: 'Expected Outcome'}
];


export const TESTS_EXECUTION_HISTORY_HEADER =[
    { property: 'executionDate', label: 'Execution Date'},
    { property: 'apServiceId', label: 'Payment Id'},
    { property: 'executionStatus', label: 'Payment Status'}
];

export const mockExecutionData = [
    {
        description: 'Process an EFT Payment to domestic beneficiary onboarded',
        country: 'US',
        paymentMethod: 'EFT',
        amount: 1000,
        ExpectedOutcome: 'Payment processed successfully',
        ExecuteIcon: '▶️'
    },
    {
        description: 'Test 1',
        country: 'US',
        paymentMethod: 'WIRE',
        amount: 2500,
        ExpectedOutcome: 'Wire sent without errors',
        ExecuteIcon: '▶️'
    },
    {
        description: 'Process an EFT Payment to domestic beneficiary onboarded with closed account',
        country: 'US',
        paymentMethod: 'EFT',
        amount: 900,
        ExpectedOutcome: 'Payment failed due to closed account',
        ExecuteIcon: '▶️'
    }
];
